var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralActionRetry = function SvgGeneralActionRetry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    fillRule: "evenodd",
    d: "m21.33 16.226-1.602.253a9.55 9.55 0 0 0 1.14-4.545c0-5.294-4.307-9.6-9.6-9.6-5.294 0-9.601 4.306-9.601 9.6s4.307 9.6 9.6 9.6v-2.163c-4.1 0-7.437-3.336-7.437-7.437 0-4.1 3.336-7.437 7.437-7.437 4.1 0 7.437 3.336 7.437 7.437 0 1.136-.28 2.223-.76 3.218l-.248-1.57-2.136.336.832 5.277 5.275-.833z",
    clipRule: "evenodd"
  })));
};
export default SvgGeneralActionRetry;